import {
    Vue, Component,
} from 'vue-property-decorator'
import util from '@/util'
import { createApiRequest } from '@/api/request'
import config from '$config'
import validate from '@/common/validate'
import { TableFiltersModule } from '../store/tableFilters'
import { TableColumnsModule } from '../store/columns'

let enterSearchFn: any = null            // 页面点击回车的搜索函数
let enterSearchFnScope: any = null       // 页面点击回车的搜索函数执行的vm

@Component
export default class GlobalMixin extends Vue {
    configCommon = config

    initialData = {}

    get commonRules() {
        const emailValidator = (rule:any, value:string, callback:Function) => {
            if (value && !validate.isEmail(value)) {
                callback(this.$t1('please_enter_a_valid_email'))
            } else {
                callback()
            }
        }
        const requiredValidator = (rule:any, value:string, callback:Function) => {
            callback((validate.isEmpty(value) || (Array.isArray(value) && !value.length)) ? new Error(this.$t1('this_field_is_required')) : undefined)
        }
        const notRequiredValidator = (rule:any, value:string, callback:Function) => {
            callback()
        }
        const mobileRule = (valueKey, countryKey) => {
            const mobileValidator = (rule:any, value:string, callback:Function) => {
                const countryInfo = this[countryKey]
                if (value === countryInfo.areaCode) {
                    util.setValueByPath(this, valueKey, '')
                    value = ''
                }
                if (!validate.isEmpty(value)
                    && (!countryInfo.areaCode || !new RegExp(countryInfo.mobileRule).test(value.slice(countryInfo.areaCode.length)))
                ) {
                    callback(this.$t1('please_enter_a_valid_phone_number'))
                } else {
                    callback()
                }
            }
            return { validator: mobileValidator, trigger: ['blur', 'change'] }
        }
        return {
            email: { validator: emailValidator, trigger: ['blur', 'change'] },
            mobileRule,
            requiredRule: { validator: requiredValidator, trigger: ['blur', 'change'], required: true },
            notRequiredRule: { validator: notRequiredValidator, trigger: ['blur', 'change'] },
        }
    }

    beforeDestroy() {
        if (enterSearchFn && this === enterSearchFnScope) {   // 绑定了搜索函数的组件销毁时清除回调函数
            enterSearchFn = null
            enterSearchFnScope = null
        }
    }

    created() {
        if ((this as any).needInitialData) {     // 保存data为函数的组件的初始data属性
            this.initialData = util.cloneDeep(this.$data)
        }
    }

    setEnterSearchFn(fn: () => void, vm: Object): void {  // 在有搜索功能的页面的created中设置搜索函数和vm对象
        enterSearchFn = fn
        enterSearchFnScope = vm
    }

    resetInitialData(arr: string[]): void { // 重置data的某些属性为默认值,参数为key的path数组:resetInitialData(['a.b.c', 'a.b.d'])
        let self: any = this
        arr.forEach((v: string): void => {
            util.setValueByPath(this, v, util.getValueByPath(self.initialData, v))
        })
    }

    proxyElUploadSubmit(args) { // 代理el-upload组件上传请求，走helper.ts
        let otherAjaxOptions: any = {
            method: 'POST',
            headers: args.headers,
        }
        let formData = new FormData()
        formData.append('file', args.file)
        if (args.data) {
            Object.keys(args.data).forEach(v => {
                formData.append(v, args.data[v])
            })
        }
        createApiRequest(args.action)(formData, otherAjaxOptions).then(res => {
            args.onSuccess(res)
        }).catch(err => {
            if (err.code) { // 如果返回了json还是用以前的onSuccess处理
                args.onSuccess(err)
            } else {        // http状态码不是200的适合用onError
                args.onError(err)
            }
        })
    }

    openSortTableFiltersDialog(tableName) {
        TableFiltersModule.SAVE_TABLE_NAME(tableName)
        TableFiltersModule.OPEN_SORT_FILTERS_DLG()
    }

    openSortTableColumnsDialog(tableName) {
        TableColumnsModule.SAVE_TABLE_NAME(tableName)
        TableColumnsModule.OPEN_SORT_COLUMNS_DLG(this.$refs[tableName])
    }

    async initTableSort(vm, refNameList: any[]) {
        refNameList.forEach(async val => {
            await TableColumnsModule.GET_TABLE_COLUMNS_CONFIG(val)
            this.handleSortColumns(vm.$refs[val])
        })
    }

    // 表格列排序
    handleSortColumns(el: Element) {
        const table: any = el
        if (!table || typeof el !== 'object') return
        this.$nextTick(() => {
            if (Object.prototype.toString.call(table) === '[object Array]') {
                table.forEach(value => {
                    value.store.states.columns = value.store.states.columns.sort((a, b) => a.index - b.index)
                    value.store.states._columns = value.store.states._columns.sort((a, b) => a.index - b.index)
                    value.store.updateColumns()
                    value.store.scheduleLayout()
                })
            } else {
                table.store.states.columns = table.store.states.columns.sort((a, b) => a.index - b.index)
                table.store.states._columns = table.store.states._columns.sort((a, b) => a.index - b.index)
                table.store.updateColumns()
                table.store.scheduleLayout()
            }
        })
    }

    openNewTab(name, params?, query?) {
        let routeUrl = this.$router.resolve(<any>{
            name,
            params,
            query,
        })
        window.open(routeUrl.href, '_blank')
    }

    refreshPage() {
        window.location.reload()
    }
}


window.addEventListener('load', () => {
    document.addEventListener('keyup', e => {   // 绑定全局回车事件
        if (e.keyCode === 13 && enterSearchFn) {
            enterSearchFn.call(enterSearchFnScope)
        }
    })
})
